module.exports = __webpack_public_path__ + "static/media/scholar.7bc81077.png";